import React, { useEffect, useState, useMemo, useRef } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { get, put, post } from "../../../../utils/api";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import FileField from "../../../../Components/Masters/FileField";
import { validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
import Multiline from "../../../../Components/Masters/Multiline";
import MonthYearPicker from "../../../../Components/Common/MonthYearPicker";
import AutoComplete from "../../../../Components/Common/AutoComplete";
import EditDialog from "../../../../Components/Common/EditDialog";
import formatTitleWithOptional from "../../OptionalFeild";
import { useUser } from "../../../../context/AuthContext";

function AddOnRoadVahicle({
  inputData,
  fetchData,
  fetchCardData,
  id,
  data,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
}) {
  const { user } = useUser();

  const initialState = {
    consumptionPeriod: {
      month: data?.consumptionPeriod?.month || "",
      year: data?.consumptionPeriod?.year || "",
    },
    ownershipType: data?.ownershipType || "",
    transportType: data?.transportType || "",
    vehicleNumber: data?.vehicleNumber || "",
    logisticsVendor: data?.logisticsVendor?._id || "",
    fuelType: data?.fuelType || "",
    fuelConsumed: {
      value: data?.fuelConsumed?.value || "",
      unit: data?.fuelConsumed?.unit || "",
    },
    distanceCovered: data?.distanceCovered || "",
    remarks: data?.remarks || "",
    documents: data?.documents || [],
    editRemarkReason: data?.editRemarkReason || "",
  };
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});

  const prevTransportType = useRef(formData.transportType);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [vehicleData, setVehicleData] = useState([]);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);
  const [isVehicleNumberDisabled, setIsVehicleNumberDisabled] = useState(true);

  const fuelTypeUnitMapping = {
    "Petrol (biofuel blend)": "Liters",
    "Petrol (mineral petrol)": "Liters",
    "Diesel (average biofuel blend)": "Liters",
    "Petrol (100% mineral petrol)": "Liters",
    "Diesel (100% mineral diesel)": "Liters",
    "Diesel (biofuel blend)": "Liters",
    "Petrol (average biofuel blend)": "Liters",
    CNG: "Kg",
    Electricity: "KWH",
  };

  useEffect(() => {
    if (formData.fuelType) {
      // Set the unit based on fuelType
      const unit = fuelTypeUnitMapping[formData.fuelType];
      if (unit) {
        setFormData((prevState) => ({
          ...prevState,
          fuelConsumed: {
            ...prevState.fuelConsumed,
            unit: unit, // Automatically set the unit based on fuel type
          },
        }));
      }
    }
  }, [formData.fuelType]);

  useEffect(() => {
    const fetchVehicleData = async () => {
      try {
        const response = await get(`/master/scope1/getAllVehicle`);
        setVehicleData(response.data.data || []);
      } catch (error) {
        console.error("Error fetching vehicle data:", error);
      }
    };
    fetchVehicleData();
  }, []);

  useEffect(() => {
    const { transportType, ownershipType, logisticsVendor } = formData;
    setIsVehicleNumberDisabled(
      !((transportType && ownershipType) || (transportType && logisticsVendor)),
    );
  }, [
    formData.transportType,
    formData.ownershipType,
    formData.logisticsVendor,
    formData,
  ]);

  console.log("first", formData);

  useEffect(() => {
    prevTransportType.current = data?.transportType || "";
  }, [data]);

  useEffect(() => {
    if (
      prevTransportType.current &&
      prevTransportType.current !== formData.transportType
    ) {
      setFormData((prevState) => ({
        ...prevState,
        ...(formData.transportType === "Freight"
          ? { ownershipType: "", logisticsVendor: "", vehicleNumber: "" }
          : formData.transportType === "Passenger"
            ? { logisticsVendor: "", vehicleNumber: "" }
            : { logisticsVendor: "", vehicleNumber: "" }),
      }));
    }

    prevTransportType.current = formData.transportType;
  }, [formData.transportType]);

  useEffect(() => {
    if (id && data) {
      setFormData({
        ...initialState,
      });
      setFormData2({
        ...initialState,
      });
      setUploadedFiles(data?.documents || []);
    } else {
      setFormData(initialState);
      setFormData2(initialState);
      setUploadedFiles([]);
    }
  }, [data, id]);

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedFiles(data?.documents || []);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "transportType") {
      setFormData((prevState) => ({
        ...prevState,
        transportType: value,
        ownershipType: value === "Freight" ? "" : prevState.ownershipType,
        logisticsVendor: "",
        vehicleNumber: "",
      }));
    } else {
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }

    setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));

    // Handle empty value for logisticsVendor
    if (name === "logisticsVendor" && value === "") {
      setFormData((prevState) => ({ ...prevState, [name]: undefined })); // Set to undefined or remove the field
    }
    // Handle nested fields for fuelConsumed
    else if (name.startsWith("fuelConsumed.")) {
      const key = name.split(".")[1];
      setFormData((prevState) => ({
        ...prevState,
        fuelConsumed: {
          ...prevState.fuelConsumed,
          [key]: value,
        },
      }));
      setErrors((prevState) => ({
        ...prevState,
        fuelConsumed: {
          ...prevState.fuelConsumed,
          [key]: "",
        },
      }));
    } else if (name === "vehicleNumber") {
      const selectedVehicle = vehicleData.find(
        (vehicle) => vehicle.vehicleNumber === value?.value,
      );
      setFormData((prevState) => ({
        ...prevState,
        vehicleNumber: value?.value,
        fuelType: selectedVehicle?.fuelType || "",
      }));
    } else if (name === "ownershipType") {
      setFormData((prevState) => ({
        ...prevState,
        ownershipType: value,
        ...(typeof value === "string" && value.toLowerCase() !== "leased"
          ? { logisticsVendor: "" }
          : {}),
      }));
    } else {
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleClose = () => {
    const isFormDataUnchanged =
      JSON.stringify(formData) === JSON.stringify(formData2);
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);

    if (isFormDataUnchanged && isFilesUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true);
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // const month = formData?.consumptionPeriod?.month;
    // const year = formData?.consumptionPeriod?.year;
    // if (!validateNumber(month)) newErrors["month"] = "Month is required";
    // if (!validateNumber(year)) newErrors["year"] = "Year is required";
    inputData.forEach((input) => {
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;
      if (input.fieldName === "consumptionPeriod") {
        if (month === "" || !validateNumber(month))
          newErrors["month"] = "Month is required";

        if (year === "" || !validateNumber(year))
          newErrors["year"] = "Year is required";

        return;
      }

      // Iterate over the inputData to validate each field
      inputData.forEach((input) => {
        const value = formData[input.fieldName] || "";

        // Validate fuelConsumed separately
        if (input.fieldName === "fuelConsumed") {
          const cvValue = formData.fuelConsumed?.value || "";
          // const cvUnit = formData.fuelConsumed?.unit || "";

          // if (!cvValue.trim()) {
          if (String(cvValue).trim() === "") {
            newErrors[input.fieldName] = {
              ...newErrors[input.fieldName],
              value: "Fuel Consumed is required.",
            };
          } else if (isNaN(cvValue)) {
            newErrors[input.fieldName] = {
              ...newErrors[input.fieldName],
              value: "Fuel Consumed must be a number.",
            };
          } else if (Number(cvValue) < 0) {
            newErrors[input.fieldName] = {
              ...newErrors[input.fieldName],
              value: "Fuel Consumed must be non-negative.",
            };
          }

          // if (!cvUnit.trim()) {
          //   newErrors[input.fieldName] = {
          //     ...newErrors[input.fieldName],
          //     unit: "Unit is required.",
          //   };
          // }
          return;
        }

        // Validation for numeric inputs
        if (input.type === "number" && !validateNumber(value)) {
          newErrors[input.fieldName] = numberError;
          return;
        }

        // Validate required fields
        if (
          input.required &&
          input.type !== "number" &&
          (!value || value === "")
        ) {
          newErrors[input.fieldName] = `${input.title} is required.`;
        }

        if (input.required && (!value || value === "")) {
          newErrors[input.fieldName] = `${input.title} is required.`;
        }

        if (
          formData.ownershipType?.toLowerCase() === "leased" &&
          input.fieldName === "logisticsVendor" &&
          (!value || value.trim() === "")
        ) {
          newErrors[input.fieldName] = "Logistics Vendor is required.";
        }

        if (
          formData.transportType === "Passenger" &&
          input.fieldName === "ownershipType" &&
          (!value || value.trim() === "")
        ) {
          newErrors[input.fieldName] = "Ownership Type  is required.";
        }

        // Validate documents upload
        // if (input.fieldName === "documents" && uploadedFiles.length === 0) {
        //   newErrors[input.fieldName] = `Please upload Documents`;
        // }
      });
      if (user?.endUser && id && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) return;
    console.log("first2", formData);
    // Prepare data to send, including only fields with values
    const dataToSend = {
      ...formData,
      documents: uploadedFiles,
    };

    // if (dataToSend.logisticsVendor === "") {
    //   delete dataToSend.logisticsVendor;
    // }
    if (dataToSend[`fuelConsumed.value`]) {
      delete dataToSend[`fuelConsumed.value`];
    }
    if (user?.endUser && id) {
      dataToSend.requestStatus = "edit";
      dataToSend.requestMode = true;
      dataToSend.approvalStatus = "Pending";
    }
    try {
      const url = id
        ? `${updateUrl}?Id=${id}` // Append the Id parameter for PUT request
        : addUrl; // Use addUrl for POST request

      const response = await (id
        ? put(url, dataToSend) // Use updated URL with Id parameter
        : post(url, dataToSend)); // For POST, no Id needed

      // Handle success
      setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });
      fetchData();
      fetchCardData();
      setFormData2({ ...formData });
      setUploadedFiles(formData.documents || []);
      handleExitAgree();
    } catch (err) {
      if (err.response && err.response.data && err.response.data.errors) {
        const errorMessages = err.response.data.errors
          .map((error) => error.msg)
          .join(", ");
        setsnackOpen({
          open: true,
          message: errorMessages,
          severity: "error",
        });
      } else if (err.response && err.response.data) {
        setsnackOpen({
          open: true,
          message: err.response.data.message,
          severity: "error",
        });
      } else {
        setsnackOpen({
          open: true,
          message: "An unknown error occurred.",
          severity: "error",
        });
      }
    }
  };

  // const filteredVehicles = useMemo(() => {
  //   if (!formData.transportType) return []; // Return empty if no transport type selected
  //   let vehicleList;
  //   if (formData.transportType === "Passenger") {
  //     if (formData?.ownershipType === "Company owned") {
  //       vehicleList = vehicleData.filter(
  //         (veh) =>
  //           veh?.transportType === "Passenger" &&
  //           veh?.ownership === "Company owned"
  //       );
  //     } else if (formData?.ownershipType === "Leased") {
  //       vehicleList = vehicleData.filter(
  //         (veh) =>
  //           veh?.transportType === "Passenger" && veh?.ownership === "Leased"
  //       );
  //     } else {
  //       vehicleList = vehicleData.filter(
  //         (veh) => veh?.transportType === "Passenger"
  //       );
  //     }
  //   } else {
  //     vehicleList = vehicleData?.filter(
  //       (veh) => veh?.transportType === "Freight"
  //     );
  //   }

  //   console.log("inside3", formData?.logisticsVendor, vehicleList);
  //   if (formData?.logisticsVendor) {
  //     vehicleList = vehicleList.filter(
  //       (veh) => veh?.logisticVendor?._id === formData?.logisticsVendor
  //     );
  //   }
  //   return vehicleList;

  //   console.log("inside34", vehicleList);
  //   return vehicleData.filter((vehicle) => {
  //     // Normalize strings for comparison
  //     const vehicleOwnership = vehicle.ownership?.toLowerCase() || "";
  //     const formOwnership = formData.ownershipType?.toLowerCase() || "";
  //     const vehicleVendor = vehicle.logisticsVendor?.toLowerCase() || "";
  //     const formVendor = formData.logisticsVendor?.toLowerCase() || "";

  //     // First check if transport type matches (case sensitive)
  //     if (vehicle.transportType !== formData.transportType) return false;

  //     // For Passenger vehicles
  //     if (formData.transportType === "Passenger") {
  //       return vehicleOwnership === formOwnership;
  //     }

  //     // For Freight vehicles
  //     if (formData.transportType === "Freight") {
  //       // If ownership is "Leased", check logistics vendor
  //       if (formOwnership === "leased") {
  //         return vehicleOwnership === "leased" && vehicleVendor === formVendor;
  //       }
  //       // For other ownership types
  //       return vehicleOwnership === formOwnership;
  //     }

  //     return false;
  //   });
  // }, [
  //   vehicleData,
  //   formData.transportType,
  //   formData.ownershipType,
  //   formData.logisticsVendor,
  // ]);

  const filteredVehicles = useMemo(() => {
    if (!formData.transportType) return [];
    let vehicleList = vehicleData.filter(
      (veh) => veh?.transportType === formData.transportType,
    );
    if (formData.ownershipType) {
      vehicleList = vehicleList.filter(
        (veh) =>
          veh?.ownership?.toLowerCase() ===
          formData.ownershipType.toLowerCase(),
      );
    }
    if (
      formData.ownershipType?.toLowerCase() === "leased" &&
      formData.logisticsVendor
    ) {
      vehicleList = vehicleList.filter(
        (veh) => veh?.logisticVendor?._id === formData.logisticsVendor,
      );
    }
    return vehicleList;
  }, [
    formData.transportType,
    formData.ownershipType,
    formData.logisticsVendor,
    vehicleData,
  ]);

  const renderInputField = (el) => {
    if (
      el.fieldName === "logisticsVendor" &&
      formData.ownershipType?.toLowerCase() !== "leased"
    ) {
      return null; // Do not render the field
    }

    if (el.options || el.type === "select") {
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          options={el.options}
          errors={errors[el.fieldName]}
          url={el.url}
          field={el.field}
        />
      );
    }

    if (el.fieldName === "vehicleNumber") {
      return (
        <AutoComplete
          title="Vehicle Number"
          name="vehicleNumber"
          options={filteredVehicles.map((vehicle) => ({
            label: `${vehicle.vehicleNumber} / ${vehicle.brand} / ${vehicle.model}`,
            value: vehicle.vehicleNumber,
          }))}
          value={formData.vehicleNumber}
          handleChange={handleChange}
          errors={errors.vehicleNumber}
          disabled={isVehicleNumberDisabled}
          noOptionsText={
            filteredVehicles.length === 0
              ? "No vehicles match your criteria"
              : "No options"
          }
        />
      );
    }

    // if (el.fieldName === "vehicleNumber") {
    //   return (
    //     <AutoComplete
    //       title="Vehicle Number"
    //       name="vehicleNumber"
    //       // options={vehicleData.map((vehicle) => vehicle.vehicleNumber )}
    //       options={vehicleData.map((vehicle) => ({
    //         label: `${vehicle.vehicleNumber} / ${vehicle.brand} / ${vehicle.model}`,
    //         value: vehicle.vehicleNumber,
    //       }))}
    //       value={formData.vehicleNumber}
    //       handleChange={handleChange}
    //       errors={errors.vehicleNumber}
    //       disabled={isVehicleNumberDisabled}
    //       // disabled={el.fieldName}

    //     />
    //   );
    // }

    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 2 }}>
          <MonthYearPicker
            title={"Consumption Month"}
            {...{
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
            }}
          />
        </Box>
      );
    }

    if (el.type === "file") {
      return (
        <FileField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles} // Make sure this is passed correctly
          progress={uploadProgress[el.fieldName] || []}
          setUploadedFiles={setUploadedFiles}
          setUploadProgress={setUploadProgress}
          setErrors={setErrors}
        />
      );
    }

    if (el.fieldName === "fuelConsumed") {
      return (
        <Box display="flex" gap={1} sx={{ width: "100%" }}>
          <Box sx={{ width: "100%" }}>
            <InputField
              title={formatTitleWithOptional(el.title)}
              handleChange={handleChange}
              placeholder={el.placeholder}
              value={formData.fuelConsumed?.value || ""}
              errors={errors[el.fieldName]?.value || errors[el.fieldName]?.unit} // Access error for value
              fieldName={"fuelConsumed.value"}
              adornmentText={formData.fuelConsumed?.unit || "Unit"}
            />
          </Box>
        </Box>
      );
    }

    if (el.fieldName === "remarks")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null;
    }

    return (
      <InputField
        title={formatTitleWithOptional(el.title)}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={formData[el.fieldName] || ""}
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
        disabled={el.fieldName === "fuelType"}
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "25.5rem", maxWidth: "100%" }}>
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? "Edit On Road Vehicle" : "Add On Road Vehicle"}
        </Typography>
        {inputData.map((el) => {
          // Conditional rendering for hours and industrial equipment
          if (
            (el.fieldName === "hours" ||
              el.fieldName === "industrialEquipment") &&
            formData.typeOfEntry !== "Individual"
          ) {
            return null; // Skip rendering these fields if typeOfEntry is not "Individual"
          }

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}

      {list()}
    </Drawer>
  );
}

export default AddOnRoadVahicle;
